// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var OptionUtils$SmartcutsMacros = require("../../../bs-utils/src/OptionUtils.bs.js");
var GoogleApis__Sheets__Schema$SmartcutsMacros = require("./GoogleApis__Sheets__Schema.bs.js");

var _map = {"Overwrite":"OVERWRITE","InsertRows":"INSERT_ROWS"};

var _revMap = {"OVERWRITE":"Overwrite","INSERT_ROWS":"InsertRows"};

function tToJs(param) {
  return _map[param];
}

function tFromJs(param) {
  return _revMap[param];
}

var InsertDataOption = {
  tToJs: tToJs,
  tFromJs: tFromJs
};

var Append = {
  InsertDataOption: InsertDataOption
};

function append(accessToken, alt, fields, key, oauthToken, prettyPrint, quotaUser, range, spreadsheetId, uploadProtocol, uploadType, valueInputOption, insertDataOption, includeValuesInResponse, responseValueRenderOption, responseDateTimeRenderOption, valueRange, client) {
  return client.spreadsheets.values.append({
                access_token: accessToken,
                alt: alt,
                fields: fields,
                key: key,
                oauth_token: oauthToken,
                prettyPrint: prettyPrint,
                quotaUser: quotaUser,
                range: range,
                spreadsheetId: spreadsheetId,
                upload_protocol: uploadProtocol,
                uploadType: uploadType,
                valueInputOption: OptionUtils$SmartcutsMacros.map(valueInputOption, GoogleApis__Sheets__Schema$SmartcutsMacros.ValueInputOption.tToJs),
                insertDataOption: _map[insertDataOption],
                includeValuesInResponse: includeValuesInResponse,
                responseValueRenderOption: OptionUtils$SmartcutsMacros.map(responseValueRenderOption, GoogleApis__Sheets__Schema$SmartcutsMacros.ValueRenderOption.tToJs),
                responseDateTimeRenderOption: OptionUtils$SmartcutsMacros.map(responseDateTimeRenderOption, GoogleApis__Sheets__Schema$SmartcutsMacros.DateTimeRenderOption.tToJs),
                resource: GoogleApis__Sheets__Schema$SmartcutsMacros.ValueRange.toWithoutEnum(valueRange)
              }).then(function (param) {
              return Promise.resolve(param.result);
            });
}

var Get = {};

function get(accessToken, alt, dateTimeRenderOption, fields, key, majorDimension, oauthToken, prettyPrint, quotaUser, range, spreadsheetId, uploadProtocol, uploadType, valueRenderOption, client) {
  return client.spreadsheets.values.get({
                access_token: accessToken,
                alt: alt,
                dateTimeRenderOption: dateTimeRenderOption,
                fields: fields,
                key: key,
                majorDimension: majorDimension,
                oauth_token: oauthToken,
                prettyPrint: prettyPrint,
                quotaUser: quotaUser,
                range: range,
                spreadsheetId: spreadsheetId,
                upload_protocol: uploadProtocol,
                uploadType: uploadType,
                valueRenderOption: valueRenderOption
              }).then(function (param) {
              return Promise.resolve(param.result);
            });
}

var Update = {};

function update(accessToken, alt, callback, fields, includeValuesInResponse, key, oauth_token, prettyPrint, quotaUser, responseDateTimeRenderOption, responseValueRenderOption, spreadsheetId, upload_protocol, uploadType, valueInputOption, range, resource, client) {
  return client.spreadsheets.values.update({
                access_token: accessToken,
                alt: alt,
                callback: callback,
                fields: fields,
                includeValuesInResponse: includeValuesInResponse,
                key: key,
                oauth_token: oauth_token,
                prettyPrint: prettyPrint,
                quotaUser: quotaUser,
                range: range,
                responseDateTimeRenderOption: responseDateTimeRenderOption,
                responseValueRenderOption: responseValueRenderOption,
                spreadsheetId: spreadsheetId,
                upload_protocol: upload_protocol,
                uploadType: uploadType,
                valueInputOption: GoogleApis__Sheets__Schema$SmartcutsMacros.ValueInputOption.tToJs(valueInputOption),
                resource: GoogleApis__Sheets__Schema$SmartcutsMacros.ValueRange.toWithoutEnum(resource)
              }).then(function (param) {
              return Promise.resolve(param.result);
            });
}

var Schema;

exports.Schema = Schema;
exports.Append = Append;
exports.append = append;
exports.Get = Get;
exports.get = get;
exports.Update = Update;
exports.update = update;
/* GoogleApis__Sheets__Schema-SmartcutsMacros Not a pure module */
